import API from "../../helpers/API";
import {
  SHOW_LOADER,
  HIDE_LOADER,
  GET_APPLICATION_LIST,
  SET_ALL_UNAPPROVAL_ENTITY_LIST,
  SET_UNAPPROVAL_PAGE_NO_COUNTER,
  GET_DUPLICATES_BY_IDS,
  GET_ALL_APPLICATION_POST_PREF_LIST,
  GET_ALL_RETOTALING_LIST,
  SET_ROLLNO_QUALIFIED_CANDIDATE,
  SET_PENDING_ACTIVITIES,
  SET_CURRENT_ACTIVITIES,
  SET_ALL_ACTIVITIES,
  SET_RECOMMENDATION_REPORTS,
} from "../../common/constants/ActionTypes";
import {
  GET_ALL_APPLICATIONS,
  APPLICATION_APPROVAL,
  ENTITYAPPROVALACTION,
  ENTITY_APPROVAL,
  GET_DUPLICATES,
  GET_APPLICATION_POST_PREF_LIST,
  APPLICATION_POST_APPROVAL,
  GET_RETOTALING_LIST,
  RETOTALING_APPROVAL,
  GET_ROLLNO_QUALIFIEDCANDIDATE,
  GET_PENDING_ACTIVITIES,
  GET_CURRENT_ACTIVITIES,
  GET_ALL_ACTIVITIES,
  GET_RECOMMENDATION_REPORTS,
} from "../../common/constants/endpoints";
import { toastr } from "react-redux-toastr";
import { handleError, handleResponseMessage } from "../../common/actions/commonActions";

export const getduplicateapi = (selectedExam, selectedValue) => {
  return async (dispatch) => {
    dispatch(showLoader());
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    try {
      let response = await API.get(
        `${GET_DUPLICATES}/${selectedExam}/${selectedValue}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (response) {
        handleResponseMessage(response);
        dispatch({
          payload: response.data,
          type: GET_DUPLICATES_BY_IDS,
        });
      }
      dispatch(hideLoader());
    } catch (error) {
      dispatch(hideLoader());
      handleError(error);
    }
  };
};

export const getApplicationList = (advertisementid) => {
  return async function (dispatch) {
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    let response;
    try {
      response = await API.get(
        `${GET_ALL_APPLICATIONS}?advertisementid=${advertisementid}`,

        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (response) {
        let responseData = response.data.optingOutList;
        dispatch({
          type: GET_APPLICATION_LIST,
          payload: responseData,
        });
        handleResponseMessage(response);
      }
    } catch (error) {
      dispatch(hideLoader());
      handleError(error);
    }
  };
};

export const getApplicationPostPrefList = (
  advertisementid,
  setApplicationData
) => {
  return async function (dispatch) {
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    let response;
    try {
      response = await API.get(
        `${GET_APPLICATION_POST_PREF_LIST}?advertisementid=${advertisementid}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (response) {
        dispatch({
          type: GET_ALL_APPLICATION_POST_PREF_LIST,
          payload: response.data,
        });
        handleResponseMessage(response);
      }
      if (response && response.data && response.data.applicationPostPrefList && response.data.applicationPostPrefList.length > 0) {
        setApplicationData(response.data.applicationPostPrefList);
      }
    } catch (error) {
      dispatch(hideLoader());
      handleError(error);
    }
  };
};

export const getRetotalingList = (advertisementid, setRetotalingData) => {
  return async function (dispatch) {
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    let response;
    try {
      response = await API.get(
        `${GET_RETOTALING_LIST}?advertisementid=${advertisementid}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (response) {
        dispatch({
          type: GET_ALL_RETOTALING_LIST,
          payload: response.data,
        });
        handleResponseMessage(response);
      }
      if (response && response.data && response.data.retotalingRequestList && response.data.retotalingRequestList.length > 0) {
        setRetotalingData(response.data.retotalingRequestList);
      }
    } catch (error) {
      dispatch(hideLoader());
      handleError(error);
    }
  };
};

export const retotalingListApprovalRequest = (retotalingData) => {
  return async (dispatch) => {
    let response;
    try {
      const session = JSON.parse(sessionStorage.getItem("session"));
      let token = session.jwtResponse && session.jwtResponse.token;

      response = await API.post(`${RETOTALING_APPROVAL}`, retotalingData, {
        headers: { Authorization: `Bearer ${token}` },
      });

      // dispatch({
      //     type: RETOTALING_DATA_UPDATED_SUCCESS,
      // });

      let successMessage =
        response && response.data ? response.data.message : response.message;
      toastr.success(successMessage);
    } catch (error) {
      handleError(error);
    }
  };
};

export const applicationPostApprovalRequest = (applicationData) => {
  return async (dispatch) => {
    let response;
    try {
      const session = JSON.parse(sessionStorage.getItem("session"));
      let token = session.jwtResponse && session.jwtResponse.token;

      response = await API.post(
        `${APPLICATION_POST_APPROVAL}`,
        applicationData,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      // dispatch({
      //     type: APPLICATION_POST_DATA_UPDATED_SUCCESS,
      // });

      let successMessage =
        response && response.data ? response.data.message : response.message;
      toastr.success(successMessage);
    } catch (error) {
      handleError(error);
    }
  };
};

export const applicationApprovalRequest = (updatedValues) => {
  return async (dispatch) => {
    let response;
    try {
      const session = JSON.parse(sessionStorage.getItem("session"));
      let token = session.jwtResponse && session.jwtResponse.token;

      response = await API.post(`${APPLICATION_APPROVAL}`, updatedValues, {
        headers: { Authorization: `Bearer ${token}` },
      });

      // dispatch({
      //     type: APPLICATION_DATA_UPDATED_SUCCESS,
      // });

      let successMessage =
        response && response.data ? response.data.message : response.message;
      toastr.success(successMessage);
    } catch (error) {
      handleError(error);
    }
  };
};

export const getAllApprovalApplicationListPagination = (
  pageNumber,
  rowPerPage
) => {
  return async function (dispatch) {
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    let response;
    try {
      response = await API.get(
        `${ENTITYAPPROVALACTION}/${pageNumber}/${rowPerPage}?entitytypes=application`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      let allDone = false;
      if (response) {

        if (response.data.approvalEmpty === true) {
          dispatch({
            type: SET_ALL_UNAPPROVAL_ENTITY_LIST,
            payload: {},
          });
        }

        response &&
          response.data &&
          response.data.entityApprovalDtoList &&
          response.data.entityApprovalDtoList.map((item, index) => {
            let details =
              item.entityApprovalAction &&
              item.entityApprovalAction.entityApprovalDto &&
              item.entityApprovalAction.entityApprovalDto.detail &&
              JSON.parse(item.entityApprovalAction.entityApprovalDto.detail);
            let parentdetails =
              item.entityApprovalAction &&
              item.entityApprovalAction.parentDetails &&
              JSON.parse(item.entityApprovalAction.parentDetails);
            response.data.entityApprovalDtoList[
              index
            ].entityApprovalAction.entityApprovalDto.detail = details;
            response.data.entityApprovalDtoList[
              index
            ].entityApprovalAction.parentdetails = parentdetails;
            if (index == response.data.entityApprovalDtoList.length - 1) {
              allDone = true;
            }
            if (allDone) {
              dispatch({
                type: SET_ALL_UNAPPROVAL_ENTITY_LIST,
                payload: response.data,
              });
              dispatch({
                type: SET_UNAPPROVAL_PAGE_NO_COUNTER,
                payload: pageNumber * rowPerPage,
              });
            }
          });
        handleResponseMessage(response);
      }
    } catch (error) {
      dispatch({
        type: SET_ALL_UNAPPROVAL_ENTITY_LIST,
        payload: {},
      });
      handleError(error);
    }
  };
};

export const getAllApprovalApplicationPostPrefListPagination = (
  pageNumber,
  rowPerPage
) => {
  return async function (dispatch) {
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    let response;
    try {
      response = await API.get(
        `${ENTITYAPPROVALACTION}/${pageNumber}/${rowPerPage}?entitytypes=applicationPostPref`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      let allDone = false;
      if (response) {

        if (response.data.approvalEmpty === true) {
          dispatch({
            type: SET_ALL_UNAPPROVAL_ENTITY_LIST,
            payload: {},
          });
        }

        response &&
          response.data &&
          response.data.entityApprovalDtoList &&
          response.data.entityApprovalDtoList.map((item, index) => {
            let details =
              item.entityApprovalAction &&
              item.entityApprovalAction.entityApprovalDto &&
              item.entityApprovalAction.entityApprovalDto.detail &&
              JSON.parse(item.entityApprovalAction.entityApprovalDto.detail);
            let parentdetails =
              item.entityApprovalAction &&
              item.entityApprovalAction.parentDetails &&
              JSON.parse(item.entityApprovalAction.parentDetails);
            response.data.entityApprovalDtoList[
              index
            ].entityApprovalAction.entityApprovalDto.detail = details;
            response.data.entityApprovalDtoList[
              index
            ].entityApprovalAction.parentdetails = parentdetails;
            if (index == response.data.entityApprovalDtoList.length - 1) {
              allDone = true;
            }
            if (allDone) {
              dispatch({
                type: SET_ALL_UNAPPROVAL_ENTITY_LIST,
                payload: response.data,
              });
              dispatch({
                type: SET_UNAPPROVAL_PAGE_NO_COUNTER,
                payload: pageNumber * rowPerPage,
              });
            }
          });
        handleResponseMessage(response);
      }
    } catch (error) {
      dispatch({
        type: SET_ALL_UNAPPROVAL_ENTITY_LIST,
        payload: {},
      });
      handleError(error);
    }
  };
};

export const getAllApprovalRetotalingListPagination = (
  pageNumber,
  rowPerPage
) => {
  return async function (dispatch) {
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    let response;
    try {
      response = await API.get(
        `${ENTITYAPPROVALACTION}/${pageNumber}/${rowPerPage}?entitytypes=retotalingRequest`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      let allDone = false;
      if (response) {

        if (response.data.approvalEmpty === true) {
          dispatch({
            type: SET_ALL_UNAPPROVAL_ENTITY_LIST,
            payload: {},
          });
        }

        response &&
          response.data &&
          response.data.entityApprovalDtoList &&
          response.data.entityApprovalDtoList.map((item, index) => {
            let details =
              item.entityApprovalAction &&
              item.entityApprovalAction.entityApprovalDto &&
              item.entityApprovalAction.entityApprovalDto.detail &&
              JSON.parse(item.entityApprovalAction.entityApprovalDto.detail);
            let parentdetails =
              item.entityApprovalAction &&
              item.entityApprovalAction.parentDetails &&
              JSON.parse(item.entityApprovalAction.parentDetails);
            response.data.entityApprovalDtoList[
              index
            ].entityApprovalAction.entityApprovalDto.detail = details;
            response.data.entityApprovalDtoList[
              index
            ].entityApprovalAction.parentdetails = parentdetails;
            if (index == response.data.entityApprovalDtoList.length - 1) {
              allDone = true;
            }
            if (allDone) {
              dispatch({
                type: SET_ALL_UNAPPROVAL_ENTITY_LIST,
                payload: response.data,
              });
              dispatch({
                type: SET_UNAPPROVAL_PAGE_NO_COUNTER,
                payload: pageNumber * rowPerPage,
              });
            }
          });
        handleResponseMessage(response);
      }
    } catch (error) {
      dispatch({
        type: SET_ALL_UNAPPROVAL_ENTITY_LIST,
        payload: {},
      });
      handleError(error);
    }
  };
};

export const approvalEntityRequest = (requestData, setShowModal) => {
  return async (dispatch) => {
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    let response;
    try {
      response = await API.patch(ENTITY_APPROVAL, requestData, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setShowModal(false);
      dispatch(getAllApprovalApplicationListPagination(0, 10));

      if (response) {
        handleResponseMessage(response);
      }

      // let successMessage =
      //   response && response.data ? response.data.message : response.message;
      // toastr.success(successMessage);
    } catch (error) {
      handleError(error);
    }
  };
};

export const applicationApprovalEntityRequest = (requestData, setShowModal) => {
  return async (dispatch) => {
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    let response;
    try {
      response = await API.patch(ENTITY_APPROVAL, requestData, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setShowModal(false);
      dispatch(getAllApprovalApplicationPostPrefListPagination(0, 10));

      if (response) {
        handleResponseMessage(response);
      }

      // let successMessage =
      //   response && response.data ? response.data.message : response.message;
      // toastr.success(successMessage);
    } catch (error) {
      handleError(error);
    }
  };
};

export const retotalingApprovalEntityRequest = (requestData, setShowModal) => {
  return async (dispatch) => {
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    let response;
    try {
      response = await API.patch(ENTITY_APPROVAL, requestData, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setShowModal(false);
      dispatch(getAllApprovalRetotalingListPagination(0, 10));

      if (response) {
        handleResponseMessage(response);
      }
      // let successMessage =
      //   response && response.data ? response.data.message : response.message;
      // toastr.success(successMessage);
    } catch (error) {
      handleError(error);
    }
  };
};

export const showLoader = () => {
  return (dispatch) => {
    dispatch({
      type: SHOW_LOADER,
    });
  };
};

export const hideLoader = () => {
  return (dispatch) => {
    dispatch({
      type: HIDE_LOADER,
    });
  };
};

export const getrollNoQualifiedCandidate = (advertisementid,examid, setPrintFlag,) => {
  return async function (dispatch) {
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    let response;
    try {
      response = await API.get(
        `${GET_ROLLNO_QUALIFIEDCANDIDATE}/?advertisementid=${advertisementid}&examid=${examid}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (response) {
        handleResponseMessage(response);
        dispatch({
          type: SET_ROLLNO_QUALIFIED_CANDIDATE,
          payload: response.data.qualifiedCandidateRollNumbersListDto,
        });
        if (response.data.qualifiedCandidateRollNumbersListDto.length > 0) {
          setPrintFlag(true);
        }
        else {
          setPrintFlag(false);
        }
      }
    } catch (error) {
      dispatch(hideLoader());
      setPrintFlag(true);
      handleError(error);
    }
  };
};

export const getPendingActivities = (selectedExam, setPrintFlag) => {
  return async (dispatch) => {
    dispatch(showLoader());
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    try {
      let response = await API.get(
        `${GET_PENDING_ACTIVITIES}?examid=${selectedExam}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (response) {
        dispatch({
          payload: response.data,
          type: SET_PENDING_ACTIVITIES,
        });
      }
      if (response.data.message === "No pending activities") {
        let successMessage =
          response && response.data ? response.data.message : response.message;
        toastr.success(successMessage);
        setPrintFlag(true);
      } else {
        setPrintFlag(false);
      }
      dispatch(hideLoader());
    } catch (error) {
      dispatch(hideLoader());
      setPrintFlag(true);
      handleError(error);
    }
  };
};

export const getCurrentActivities = (selectedExam, setPrintFlag) => {
  return async (dispatch) => {
    dispatch(showLoader());
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    try {
      let response = await API.get(
        `${GET_CURRENT_ACTIVITIES}?examid=${selectedExam}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (response) {
        dispatch({
          payload: response.data,
          type: SET_CURRENT_ACTIVITIES,
        });
      }
      // let successMessage =
      //   response && response.data ? response.data.message : response.message;
      // toastr.success(successMessage);
      setPrintFlag(false);
      dispatch(hideLoader());
    } catch (error) {
      dispatch(hideLoader());
      setPrintFlag(true);
      handleError(error);
    }
  };
};

export const getallActivities = (selectedExam, setPrintFlag) => {
  return async (dispatch) => {
    dispatch(showLoader());
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    try {
      let response = await API.get(
        `${GET_ALL_ACTIVITIES}?examid=${selectedExam}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (response) {
        handleResponseMessage(response);
        dispatch({
          payload: response.data,
          type: SET_ALL_ACTIVITIES,
        });
      }
      // let successMessage =
      //   response && response.data ? response.data.message : response.message;
      // toastr.success(successMessage);
      setPrintFlag(false);
      dispatch(hideLoader());
    } catch (error) {
      dispatch(hideLoader());
      setPrintFlag(true);
      handleError(error);
    }
  };
};

export const printrecommendationReport = (
  selectedExam,
  selectedlist,
  setPrintFlag
) => {
  return async (dispatch) => {
    dispatch(showLoader());
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    try {
      let response = await API.get(
        `${GET_RECOMMENDATION_REPORTS}?examid=${selectedExam}&type=${selectedlist}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (response) {
        if (
          response.data.vacantPosition &&
          response.data.vacantPosition.length > 0
        ) {
          setPrintFlag(false);
        } else if (response.data.vacantPosition &&
          response.data.vacantPosition.length == 0) {
          setPrintFlag(true);
          // toastr.error("No record found");
        } else if (response.data.recommendationReportType == "meritlist" || "postwiserecolist"
        ) {
          setPrintFlag(false);
        } else {
          setPrintFlag(true);
        }
        dispatch({
          payload: response.data,
          type: SET_RECOMMENDATION_REPORTS,
        });
        handleResponseMessage(response);
      }

      dispatch(hideLoader());
    } catch (error) {
      dispatch(hideLoader());
      setPrintFlag(true);
      handleError(error);
    }
  };
};
